/**
 * 統一的錯誤訊息提取工具函數
 * 處理各種可能的錯誤格式，確保返回字串而不是物件
 */
export const extractErrorMessage = (error: any): string => {
  // 如果是字串，直接返回
  if (typeof error === 'string') return error;
  
  // 檢查常見的錯誤格式
  if (error?.response?.data) {
    const data = error.response.data;
    
    // 格式: {error: {message: string}}
    if (data.error?.message) return data.error.message;
    
    // 格式: {error: string}
    if (typeof data.error === 'string') return data.error;
    
    // 格式: {message: string}
    if (data.message) return data.message;
    
    // 格式: {code: string, message: string}
    if (data.code && data.message) return `${data.code}: ${data.message}`;
  }
  
  // 檢查 error.message
  if (error?.message) return error.message;
  
  // 預設訊息
  return '發生未知錯誤';
};

/**
 * 用於 API 回應錯誤的專用提取函數
 */
export const extractApiErrorMessage = (error: any, defaultMessage: string = '操作失敗'): string => {
  const extracted = extractErrorMessage(error);
  return extracted === '發生未知錯誤' ? defaultMessage : extracted;
};